module.exports = __webpack_public_path__ + "img/plus_pan.0f420ba5.svg";